/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    bool, object, string, shape, array, arrayOf, number, func,
} from 'prop-types';
import DesktopPlantsAddToCart from './Desktop/DesktopPlantsAddToCart';

const GraphqlPlantsAddToCart = (props) => {
    const {
        isAddToCartEnabled,
        selectedItemId,
        brandId,
        partNumber,
        subscriptionDetails,
        productType,
        totalProductSelected,
        maxComponents,
        cyoSelectedComponents,
        fullWidth,
        disableAddToCart,
        personalizedData,
        isPersonalizable,
        product,
        presentation_family,
        addons,
        closeAddonModal,
        handleMiniCartModalClick,
        quantity,
        isBandItemSelected,
        handleMobileAgeVerification,
        isMobile,
        hasWine,
        isPassportBundleProduct,
        setAddToCartClicked,
        selectedState,
        deliveryDate,
        stateEnabled,
        alertType,
        selectedSku,
        location,
    } = props;
    return (
        <>
            <DesktopPlantsAddToCart
                isAddToCartEnabled={isAddToCartEnabled}
                selectedItemId={selectedItemId}
                brandId={brandId}
                partNumber={partNumber}
                subscriptionDetails={subscriptionDetails}
                productType={productType}
                totalProductSelected={totalProductSelected}
                maxComponents={maxComponents}
                cyoSelectedComponents={cyoSelectedComponents}
                fullWidth={fullWidth}
                disableAddToCart={disableAddToCart}
                personalizedData={personalizedData}
                isPersonalizable={isPersonalizable}
                product={product}
                presentation_family={presentation_family}
                addons={addons}
                closeAddonModal={closeAddonModal}
                // IMP for minicart as it handels it open and close of minicart(NB: not needed in mobile)
                handleMiniCartModalClick={handleMiniCartModalClick}
                quantity={quantity}
                isBandItemSelected={isBandItemSelected}
                handleMobileAgeVerification={handleMobileAgeVerification}
                hasWine={hasWine}
                isMobile={isMobile}
                isPassportBundleProduct={isPassportBundleProduct || {}}
                setAddToCartClicked={setAddToCartClicked}
                selectedState={selectedState}
                deliveryDate={deliveryDate}
                stateEnabled={stateEnabled}
                alertType={alertType}
                selectedSku={selectedSku}
                location={location}
            />
        </>
    );
};

GraphqlPlantsAddToCart.propTypes = {
    selectedItemId: string,
    brandId: string.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
        subscriptionDurationKey: string,
    }),
    productType: string,
    totalProductSelected: number,
    maxComponents: number,
    cyoSelectedComponents: array,
    fullWidth: bool,
    product: object.isRequired,
    presentation_family: string,
    disableAddToCart: bool,
    personalizedData: shape({
        personalizationType: string,
        personalizationLines: arrayOf({
            perAttributeValue: string,
        }),
    }),
    isPersonalizable: bool,
    isAddToCartEnabled: bool,
    addons: arrayOf(shape({
        brandCode: string,
        productCode: number,
        componentType: string,
        productId: string,
        quantity: number,
    })),
    isBandItemSelected: bool,
    closeAddonModal: func,
    handleMiniCartModalClick: func,
    quantity: string,
    handleMobileAgeVerification: func,
    isMobile: bool,
    hasWine: bool,
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    setAddToCartClicked: func,
    selectedState: bool,
    deliveryDate: string.isRequired,
    stateEnabled: bool.isRequired,
    alertType: string,
    selectedSku: object.isRequired,
    location: object.isRequired,
    partNumber: string,
};

GraphqlPlantsAddToCart.defaultProps = {
    selectedItemId: null,
    fullWidth: false,
    subscriptionDetails: {},
    productType: '',
    totalProductSelected: 0,
    maxComponents: null,
    cyoSelectedComponents: [],
    disableAddToCart: false,
    personalizedData: {},
    isPersonalizable: false,
    presentation_family: 'plants',
    addons: [],
    closeAddonModal: () => { },
    handleMiniCartModalClick: () => { },
    quantity: '1',
    isBandItemSelected: true,
    partNumber: '',
    isAddToCartEnabled: false,
    handleMobileAgeVerification: () => { },
    isMobile: false,
    hasWine: false,
    isPassportBundleProduct: {},
    setAddToCartClicked: () => { },
    selectedState: false,
    alertType: '',
};

export default GraphqlPlantsAddToCart;
